import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/sharun-store/drive/layouts/default.vue").then(m => m.default || m))
}